module.exports = __webpack_public_path__ + "static/img/10011 (4).c2371bb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10011 (4).webp
// module id = u9VG
// module chunks = 14